import { render, staticRenderFns } from "./UnauthenticatedLayout.vue?vue&type=template&id=ec9bec4e&"
import script from "./UnauthenticatedLayout.vue?vue&type=script&lang=ts&"
export * from "./UnauthenticatedLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports